import { render, staticRenderFns } from "./cooperation.vue?vue&type=template&id=4f326dca&scoped=true&"
import script from "./cooperation.vue?vue&type=script&lang=js&"
export * from "./cooperation.vue?vue&type=script&lang=js&"
import style0 from "./cooperation.vue?vue&type=style&index=0&id=4f326dca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f326dca",
  null
  
)

export default component.exports